<div></div>
<div class="app-tool-panel" fxLayout="column">
  <div class="app-tool-panel-headline" fxLayout="row" fxLayoutAlign="space-between center">
    <span>Vous n'avez acces à aucune page. Contactez votre administrateur pour obtenir des droit d'acces</span>
  </div>
</div>
